export default {
  meta: {
    title: '操作日志', // 系统管理-操作日志
  },
};
